import React, { useEffect, useState } from 'react';
import './PinPad.scss';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, CircularProgress, Backdrop } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Modal } from '@mui/material';
import CustomAlert from '../UI/CustomAlert/CustomAlert';
import { sendEmailPIN } from '../../util/API/passwordpinchange';

const PinPad = ({show, handleConfirm, onClick, loading}) => {
  const [isConfirming, setIsConfirming] = useState(false);
    const [pin, setPin] = useState([]);
    const numbers = [7, 8, 9, 4, 5, 6, 1, 2, 3, 'delete', 0, 'confirm'];
    const [alert, setAlert] = useState(
        {
          showAlert: false,
          severity: "error",
          header: "",
          message: "",
          confirmButton: null,
          alertType: ''
        }
      )

      let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body
      let isOperator = sessionStorage.getItem("isOperator")

      useEffect(() => {
        if (show) {
            setPin([]); // Reset the pin state whenever the modal is shown
            setIsConfirming(false);
        }
      }, [show]);

      useEffect(() => {
        const handleKeyDown = (event) => {
          const { key } = event;
      
          if (!show) return; // Only listen when the modal is open
      
          if (!isNaN(key) && pin.length < 4) {
            setPin((prev) => [...prev, parseInt(key)]);
          } else if (key === 'Backspace') {
            setPin((prev) => prev.slice(0, -1));
          } 
          // else if (key === 'Enter') {
          //   if (pin.length < 4) {
          //     setAlert({
          //       ...alert,
          //       showAlert: true,
          //       severity: "error",
          //       header: "Error",
          //       message: "The PIN should be 4 digits",
          //     })
          //     return;
          //   }
          //   handleConfirm(event, pin);
          // }
        };
      
        window.addEventListener('keydown', handleKeyDown);
      
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, [pin, handleConfirm, show]);
      

      const onClickForgotPIN = () => {

        setAlert({
          ...alert,
          showAlert: true,
          severity: "confirm",
          header: "Confirm",
          message: "The PIN will be sent to your registered contact information. Would you like to proceed?",
          alertType: 'confirm',
          confirmButton: () => sendEmailPin()
        })
    
      }
    
      const sendEmailPin = async() => {
    
        try {
    
          const response = await sendEmailPIN(
            agent['User'].other1,
            agent['Useremailaccount'].emailAccount,
            agent['User'].id,
            agent['User'].franchiseeID,
            agent['User'].telephoneno,
            agent['User'].countryid,
            isOperator
          )
    
          console.log(response)
    
          if (response?.callStatus === "1") {
            setAlert({
              ...alert,
              showAlert: true,
              severity: "success",
              header: "Success",
              message: response?.msg,
              alertType: '',
              confirmButton: null
            })
          }
    
          else {
            setAlert({
              ...alert,
              showAlert: true,
              severity: "error",
              header: "Error",
              message: response?.payload?.data?.header?.msg,
              alertType: '',
              confirmButton: null
            })
          }
    
        }
        catch (error) {
          console.log(error)
        }
    
      }


    const handleNumberClick = (e, number) => {
        if (number === 'delete') {
            setPin(pin.slice(0, -1));
        } else if (number === 'confirm') {
          if (isConfirming) return;
            if (pin.length < 4) {
              setAlert({
                ...alert,
                showAlert: true,
                severity: "error",
                header: "Error",
                message: "The PIN should be 4 digits",
              })
              return;
            }
            setIsConfirming(true);
            handleConfirm(e, pin);
        } else {
            if (pin.length < 4) {
                setPin([...pin, number]);
            }
        }
    };

    useEffect(() => {
        console.log(pin);
    }, [pin]);
    useEffect(() => {
  if (loading === false) {
    setIsConfirming(false); // request finished (success or fail) — allow retry
  }
}, [loading]);
    if (!show) return null;

    return (
        // <Box className="modal-style">
        <Modal
            open={show}
            onClose={onClick}
            className="modal-style"
            >
            <Box className="container-style">
                <IconButton className="close-cross-style" onClick={onClick}>
                    <CloseIcon />
                </IconButton>
                <p className="header-style">Wallet PIN</p>
                
                <Box className="pin-container">
                    {Array(4).fill('').map((_, index) => (
                        <Box key={index} className="pin-box">
                            {pin[index] !== undefined ? '*' : ''}
                        </Box>
                    ))}
                </Box>

                <Box className="keypad-container">
                    {numbers.map((number, index) => (
                        <Box key={index} className={`keypad-box ${number === 'delete' ? 'delete-box' : ''} ${number === 'confirm' ? 'confirm-box' : ''}`}>
                            <button className="numbers-style" onClick={(e) => handleNumberClick(e, number)}
>
                                {number !== 'delete' && number !== 'confirm' ? number : ''}
                            </button>
                            {number === 'delete' && 
                                <IconButton className="delete-icon-style" onClick={(e) => handleNumberClick(e, number)}>
                                    <CloseIcon />
                                </IconButton>
                            }

                            {number === 'confirm' && 
                                <IconButton className="confirm-icon-style" onClick={(e) => handleNumberClick(e, number)}
                                 disabled={isConfirming}>
                                    <CheckCircleIcon />
                                </IconButton>
                            }
                        </Box>
                    ))}
                </Box>

                <button 
                    className="forgot-pin-style"
                    onClick={onClickForgotPIN}
                >
                    Forgot PIN?
                </button>

                {loading && (
                    <Backdrop
                        sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.modal + 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: "25px",
                        }}
                        open={loading}
                    >
                        <CircularProgress size={40} sx={{ color: "#ff972c", mb: 2 }} />
                        <p>Processing...</p>
                    </Backdrop>
                )}
                <CustomAlert
                    severity={alert.severity}
                    show={alert.showAlert}
                    header={alert.header}
                    message={alert.message}
                    onClick={() => {setAlert({ ...alert, showAlert: false })}}
                    alertType={alert.alertType}
                    confirmButton={alert.confirmButton}
                    autoclose={alert.severity === "error" ? false : true}
                />
            </Box>
            </Modal>
    );
};

export default PinPad;
